import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=90ef0abe&scoped=true&"
import script from "./MainOrder.vue?vue&type=script&lang=ts&"
export * from "./MainOrder.vue?vue&type=script&lang=ts&"
import style0 from "./MainOrder.vue?vue&type=style&index=0&id=90ef0abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ef0abe",
  null
  
)

export default component.exports